module.exports = __webpack_public_path__ + "static/media/logo.247d05fb.png";